import MaterialButton, { ButtonProps } from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Field, FieldProps } from 'formik';
import React from 'react';

const Button = withStyles(theme => ({
  root: {
    borderRadius: 0,
    color: 'rgba(0, 0, 0, 0.8)',
    backgroundColor: 'rgba(0, 0, 0, 0.1)'
  }
}))(MaterialButton);

export default function ResetButton(props: ButtonProps) {
  return (
    <Field>
      {({ form }: FieldProps) => (
        <Button onClick={() => form.resetForm()} {...props}>
          {props.children}
        </Button>
      )}
    </Field>
  );
}
